<template>
	<div class="products_page">
		<!-- 顶部标题�?-->
		<div class="page_header">
			<div class="back_btn" @click="$router.go(-1)">
				<img src="../../../src/assets/images/return.png" alt="">
			</div>
			<div class="page_title">蚂蚁金服</div>
		</div>

		<!-- 产品列表 -->
		<div class="products_list">
			<div class="product_item" @click="goToProduct('zhongyin')">
				<div class="product_icon red_icon">
					<img src="../../../src/assets/images/short/short1.png" alt="">
				</div>
				<div class="product_info">
					<div class="product_name">短期中银宝（1小时）</div>
				</div>
				<div class="arrow_icon"><img src="../../../src/assets/images/goto.png" alt=""></div>
			</div>

			<div class="product_item" @click="goToProduct('yuebao')">
				<div class="product_icon yellow_icon">
					<img src="../../../src/assets/images/short/short2.png" alt="">
				</div>
				<div class="product_info">
					<div class="product_name">短期余额宝（3小时）</div>
				</div>
				<div class="arrow_icon"><img src="../../../src/assets/images/goto.png" alt=""></div>
			</div>

			<div class="product_item" @click="goToProduct('yulibao')">
				<div class="product_icon blue_icon">
					<img src="../../../src/assets/images/short/short3.png" alt="">
				</div>
				<div class="product_info">
					<div class="product_name">短期余利宝（7小时）</div>
				</div>
				<div class="arrow_icon"><img src="../../../src/assets/images/goto.png" alt=""></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Products",
	data() {
		return {
			// 页面数据
		};
	},
	methods: {
		goToProduct(productType) {
			// 跳转到项目详情页面
			this.$router.push('/projectDetail');
		}
	}
};
</script>

<style lang="less" scoped>
.products_page {
	// min-height: 100vh;
	background-color: #f7f7f7;
}

.page_header {
	position: relative;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	// border-bottom: 1px solid #f0f0f0;

	.back_btn {
		position: absolute;
		left: 16px;
		height: 44px;
		display: flex;
		align-items: center;
		cursor: pointer;
		img{
			width: 16px;
		}

		.back_icon {
			font-size: 24px;
			color: #1989fa;
			font-weight: bold;
		}
	}

	.page_title {
		font-size: 16px;
		color: #000;
		font-weight: 500;
	}
}

.products_list {
	padding: 10px;

	.product_item {
		display: flex;
		align-items: center;
		padding: 16px;
		// margin-bottom: 12px;
		background: #fff;
		border-radius: 8px;
		// border: 1px solid #f0f0f0;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		}

		.product_icon {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 16px;
			img{
				width: 100%;
				height: 100%;
			}

			// &.red_icon {
			// 	background: #ff4d4f;
			// }

			// &.yellow_icon {
			// 	background: #faad14;
			// }

			// &.blue_icon {
			// 	background: #1890ff;
			// }

			.currency_symbol {
				color: #fff;
				font-size: 20px;
				font-weight: bold;
			}
		}

		.product_info {
			flex: 1;
			display: flex;

			.product_name {
				font-size: 14px;
				color: #323233;
				font-weight: 500;
			}

			.product_duration {
				font-size: 14px;
				color: #999;
			}
		}

		.arrow_icon {
			font-size: 18px;
			color: #ccc;
			margin-left: 8px;
			img{
				width: 16px;
			}
		}
	}
}
</style> 
